export enum FeatureFlags {
  DropboxSync = "dropbox-sync",
}

export const FEATURE_FLAGS = {
  [FeatureFlags.DropboxSync]: true,
};
